/* ═══════════════════════════════════════════════════════
   Monmouth Cards — Collection Page JS
   assets/monmouth-collection.js
   ═══════════════════════════════════════════════════════ */

(function() {
  'use strict';

  /* Real fix (pre-launch-remaining-fixes-prompt.md, Part 2) — confirmed
     live: this file is loaded twice on every real collection page, once
     sitewide via layout/theme.liquid and again unconditionally via
     sections/monmouth-collection-filters.liquid. With no guard, its full
     setup below (view toggle, sort select, every filter link, the AJAX
     bootstrap) ran twice for every real visitor — not an edge case like
     the admin-preview scenario the account-page bug lived in. Same
     pattern already proven in assets/monmouth-cart.js and
     assets/monmouth-mobile-fixes.js. */
  if (window.__mcCollectionInit) return;
  window.__mcCollectionInit = true;

  var SECTION_ID = 'monmouth-collection-filters';

  /* Storage can throw (blocked / private mode): always go through the shared safe helper (assets/monmouth-safe-storage.js),
     with a harmless local fallback if that file is not there. A blocked storage only means "view mode not remembered". */
  function mcStoreGet(k) { try { return window.mcStorage ? window.mcStorage.get(k) : localStorage.getItem(k); } catch (e) { return null; } }
  function mcStoreSet(k, v) { try { if (window.mcStorage) window.mcStorage.set(k, v); else localStorage.setItem(k, v); } catch (e) { /* not remembered */ } }

  /* ══════════════════════════════════════════════════════
     GRID / LIST TOGGLE
  ══════════════════════════════════════════════════════ */
  function initViewToggle() {
    var toggleBtns = document.querySelectorAll('.mc-view-toggle__btn');
    if (!toggleBtns.length) return;

    var saved = mcStoreGet('mc-view-mode');
    if (saved === 'list') setView('list');

    toggleBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var mode = btn.dataset.view;
        setView(mode);
        mcStoreSet('mc-view-mode', mode);
      });
    });
  }

  function setView(mode) {
    var g = document.getElementById('mc-product-grid');
    if (!g) return;
    g.classList.toggle('mc-product-grid--list', mode === 'list');
    document.querySelectorAll('.mc-view-toggle__btn').forEach(function(b) {
      var active = b.dataset.view === mode;
      b.classList.toggle('mc-view-toggle__btn--active', active);
      b.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  /* ══════════════════════════════════════════════════════
     MOBILE FILTER SHEET
  ══════════════════════════════════════════════════════ */
  function initFilterSheet(keepOpen) {
    var sheet   = document.getElementById('mc-filter-sheet');
    var overlay = document.getElementById('mc-filter-sheet-overlay');
    var closeBtn = document.getElementById('mc-filter-sheet-close');
    /* New — header ✕ (filter-panel-redesign-prompt.md Part 2). Same
       closeSheet() the overlay/"Show X Results" already use; not a second
       close implementation. */
    var xBtn = document.getElementById('mc-filter-sheet-x');

    function openSheet(ev) {
      if (!sheet) return;
      var trigger = ev && ev.currentTarget && ev.currentTarget.nodeType === 1 ? ev.currentTarget : null;
      sheet.classList.add('mc-filter-sheet--active');
      if (overlay) overlay.classList.add('mc-filter-sheet-overlay--active');
      document.body.style.overflow = 'hidden';
      /* ENG-08: sheet focusable, page behind inert, Tab trapped, Escape closes, focus returns to the trigger */
      if (window.mcDialog) {
        window.mcDialog.open(sheet, {
          opener: trigger || undefined,
          keep: overlay ? [overlay] : [],
          escape: closeSheet,
          initialFocus: xBtn || closeBtn
        });
      }
    }
    function closeSheet() {
      if (!sheet) return;
      sheet.classList.remove('mc-filter-sheet--active');
      if (overlay) overlay.classList.remove('mc-filter-sheet-overlay--active');
      document.body.style.overflow = '';
      if (window.mcDialog) window.mcDialog.close(sheet);
    }

    var trig1 = document.getElementById('mc-filter-sheet-open');
    var trig2 = document.getElementById('mc-more-filters-trigger');
    if (trig1)    trig1.addEventListener('click', openSheet);
    if (trig2)    trig2.addEventListener('click', openSheet);
    if (overlay)  overlay.addEventListener('click', closeSheet);
    if (closeBtn) closeBtn.addEventListener('click', closeSheet);
    if (xBtn)     xBtn.addEventListener('click', closeSheet);

    /* Real fix — re-apply the open state (classes + scroll lock) on the
       freshly-swapped-in sheet/overlay when it was open right before this
       swap, via the exact same openSheet() the trigger buttons use, so a
       filter tap from inside the sheet updates results live instead of
       closing it. See sheetWasActiveBeforeSwap above. */
    if (keepOpen) openSheet();
  }

  /* ══════════════════════════════════════════════════════
     SIDEBAR SCRIPTS
     Called after every section replace
  ══════════════════════════════════════════════════════ */
  function initSidebarScripts() {
    /* Collapsible groups */
    document.querySelectorAll('.mc-sidebar__group-toggle').forEach(function(btn) {
      var fresh = btn.cloneNode(true);
      btn.parentNode.replaceChild(fresh, btn);
      fresh.addEventListener('click', function() {
        var group  = this.closest('.mc-sidebar__group');
        var isOpen = group.classList.contains('mc-sidebar__group--open');
        group.classList.toggle('mc-sidebar__group--open', !isOpen);
        this.setAttribute('aria-expanded', String(!isOpen));
      });
    });

    /* Show more / less */
    document.querySelectorAll('.mc-sidebar__more').forEach(function(btn) {
      var fresh = btn.cloneNode(true);
      btn.parentNode.replaceChild(fresh, btn);
      fresh.addEventListener('click', function() {
        var body       = this.closest('.mc-sidebar__group-body');
        var showCount  = parseInt(this.dataset.showCount, 10);
        var total      = parseInt(this.dataset.total, 10);
        var isExpanded = this.dataset.expanded === 'true';
        if (!isExpanded) {
          body.querySelectorAll('.mc-sidebar__option--hidden').forEach(function(el) {
            el.classList.remove('mc-sidebar__option--hidden');
          });
          this.textContent = '− Show less';
          this.dataset.expanded = 'true';
        } else {
          body.querySelectorAll('.mc-sidebar__option').forEach(function(el, i) {
            if (i >= showCount && !el.classList.contains('mc-sidebar__option--selected')) {
              el.classList.add('mc-sidebar__option--hidden');
            }
          });
          this.textContent = '+ ' + (total - showCount) + ' more';
          this.dataset.expanded = 'false';
        }
      });
    });
  }

  /* ══════════════════════════════════════════════════════
     SORT SELECT
     2026-07-16: originally 4 of 5 options (Featured/Newest/Best Selling/
     Ending Soon) were tag filters wearing a sort dropdown's clothes —
     each shows ONLY products carrying that literal tag (sort-featured/
     sort-newest/sort-Bestseller/sort-endingSoon), not a reordering of
     the full set. Only "Price" was a genuine native sort, toggling
     ascending/descending on repeated selection rather than being two
     separate menu rows (data-current-sort-by on that <option>, set by
     Liquid, is how this reads "which direction am I on right now").
     2026-08-2X: Newest moved to the native-sort side too (team decision
     — real date sort across the whole catalog, see
     phase-4-newest-sort-and-per-page-prompt.md), modeled directly on the
     Price branch (data-native-sort-by on that <option>, set by Liquid,
     carries the exact collection.sort_by value to switch to — no
     ascending/descending toggle needed, unlike Price, since there's only
     one direction for "Newest"). Featured/Best Selling/Ending Soon are
     still routed through multiSelect.toggle() so they go through the
     exact same pipeline (URL building, AJAX fetch, pill rendering,
     composing with every other active filter) as every other
     single-toggle filter in this file — the 4-way exclusivity between
     them is handled by EXCLUSIVE_PAIRS above, not here.
  ══════════════════════════════════════════════════════ */
  /* 2026-10-12: Price is now two ordinary native options ("Price: Low to High" / "Price: High to Low", each with its own
     data-native-sort-by). The old single "Price" option flipped direction on repeated selection, which a <select> cannot
     deliver (picking the already-selected option fires no change event), so the descending order was unreachable.
     A sort change also starts again at page 1 (page / cp are dropped). */
  function bindSortSelect() {
    document.querySelectorAll('.mc-filters-bar__sort-select').forEach(function(sel) {
      if (sel._mc_bound) return;
      sel._mc_bound = true;
      sel.addEventListener('change', function() {
        var opt = this.options[this.selectedIndex];
        var kind = opt.getAttribute('data-sort-kind');
        if (kind === 'native') {
          var nativeSortBy = opt.getAttribute('data-native-sort-by');
          var url = new URL(window.location.href);
          url.searchParams.set('sort_by', nativeSortBy);
          /* a different order starts again at page 1 */
          url.searchParams.delete('page'); url.searchParams.delete('cp');
          fetchAndReplace(url.toString());
        } else {
          multiSelect.toggle(this.value, null);
        }
      });
    });
  }

  /* ══════════════════════════════════════════════════════
     AJAX — SHOPIFY SECTIONS RENDERING API
     Fetches /collections/X?filter=Y&sections=SECTION_ID
     Shopify returns JSON with perfectly rendered section HTML
     (correct filtered count, active filter states, updated grid)
  ══════════════════════════════════════════════════════ */
  var isLoading = false;
  /* Real fix — swapSectionHtml() below replaces .mc-collection-section's
     entire innerHTML with fresh server HTML, including #mc-filter-sheet/
     #mc-filter-sheet-overlay themselves, which always render in their
     default closed state. Without this, tapping a filter INSIDE the
     mobile sheet visually slams it shut on every tap, even though the
     tap correctly updates the results underneath. Captured right before
     each swap, consumed (and reset) by reinitAfterSwap() right after —
     see swapSectionHtml/initFilterSheet. */
  var sheetWasActiveBeforeSwap = false;

  function showLoading() {
    var section = document.querySelector('.mc-collection-section');
    if (section) {
      section.style.opacity = '0.45';
      section.style.pointerEvents = 'none';
      section.style.transition = 'opacity 0.15s';
    }
    /* Spinner */
    if (!document.getElementById('mc-ajax-spinner')) {
      var wrap = document.querySelector('.mc-collection-main') || document.querySelector('.mc-collection-section');
      if (wrap) {
        var sp = document.createElement('div');
        sp.id = 'mc-ajax-spinner';
        sp.innerHTML = '<div style="width:40px;height:40px;border:3px solid #e5e7eb;border-top-color:#0A1F44;border-radius:50%;animation:mc-spin .65s linear infinite;margin:auto;"></div>';
        sp.style.cssText = 'position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);z-index:999;';
        if (!document.getElementById('mc-spin-kf')) {
          var s = document.createElement('style');
          s.id = 'mc-spin-kf';
          s.textContent = '@keyframes mc-spin{to{transform:rotate(360deg)}}';
          document.head.appendChild(s);
        }
        document.body.appendChild(sp);
      }
    }
  }

  function hideLoading() {
    var sp = document.getElementById('mc-ajax-spinner');
    if (sp) sp.remove();
    var section = document.querySelector('.mc-collection-section');
    if (section) {
      section.style.opacity = '';
      section.style.pointerEvents = '';
    }
  }

  /* Raw fetch of one collection URL's rendered section HTML — no swap,
     no history, no re-init. Building block for both the simple
     single-URL flow and the multi-select merge flow below. */
  function fetchSectionHtml(url) {
    var sep = url.indexOf('?') >= 0 ? '&' : '?';
    var apiUrl = url + sep + 'sections=' + SECTION_ID;
    return fetch(apiUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function(r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function(data) {
        var html = data[SECTION_ID];
        if (!html) throw new Error('Section not found in response');
        return html;
      });
  }

  /* Real fix (general-filters-wrong-tags-and-empty-state-prompt.md) —
     Shopify's own tag-URL routing 30x-redirects a path segment that
     doesn't handleize-match any real tag anywhere in the shop, dropping
     it and serving the unfiltered collection instead (confirmed live —
     this is exactly what New Releases/Pre-Order were hitting before
     their tag values were fixed, and it's a platform behavior, not
     something a Liquid template can opt out of). fetch() follows that
     redirect transparently, so a plain fetchSectionHtml() can't tell
     "0 real matches" apart from "silently got the wrong, unfiltered
     page" — this checks the response's own final .url (after redirects)
     against what was actually requested, and reports it, so a tag
     combo that got redirected can be treated as 0 real matches instead
     of trusted at face value. Only used by the tag-combo fetches below
     (renderCombos' primary fetch and the multi-select merge helpers) —
     not by fetchSectionHtml's other callers (plain pagination, sort),
     which have nothing to redirect away from. */
  function fetchSectionHtmlChecked(url) {
    var sep = url.indexOf('?') >= 0 ? '&' : '?';
    var apiUrl = url + sep + 'sections=' + SECTION_ID;
    return fetch(apiUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function(r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        /* tag segments in a different order are the same page (Shopify just redirects to its own order): not a "tag not found" */
        function normPath(u) {
          return new URL(u, window.location.origin).pathname.replace(/\/+$/, '').replace(/(\/collections\/[^/]+\/)(.+)$/, function(m, a, b) { return a + b.split('+').sort().join('+'); });
        }
        var requestedPath = normPath(url);
        var finalPath = normPath(r.url);
        var wasRedirected = requestedPath !== finalPath;
        return r.json().then(function(data) { return { data: data, wasRedirected: wasRedirected }; });
      })
      .then(function(res) {
        var html = res.data[SECTION_ID];
        if (!html) throw new Error('Section not found in response');
        return { html: html, wasRedirected: res.wasRedirected };
      });
  }

  function swapSectionHtml(html) {
    var section = document.querySelector('.mc-collection-section');
    /* Real fix — capture whether the mobile filter sheet was open BEFORE
       replacing it out from under itself; reinitAfterSwap() re-applies
       this on the new DOM right after. */
    var sheet = document.getElementById('mc-filter-sheet');
    sheetWasActiveBeforeSwap = !!(sheet && sheet.classList.contains('mc-filter-sheet--active'));
    if (section) section.innerHTML = html;
  }

  /* ENG-09: say "Results updated: 12 products" when the visible product count changes (filters, sort, Great Deal scan).
     The count element is redrawn by several code paths, so watch it instead of patching each one; debounced so a scan that
     updates it repeatedly announces once. */
  function initResultsAnnouncer() {
    var root = document.querySelector('main') || document.body;
    if (!root || !window.MutationObserver) return;
    function readCount() {
      var el = document.querySelector('.mc-collection-header__count');
      return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
    }
    var last = readCount();
    var timer = null;
    function touchesCount(m) {
      var t = m.target && m.target.nodeType === 1 ? m.target : (m.target && m.target.parentElement);
      if (t && t.closest && t.closest('.mc-collection-header__count')) return true;
      for (var i = 0; i < m.addedNodes.length; i++) {
        var n = m.addedNodes[i];
        if (n.nodeType === 1 && (n.matches('.mc-collection-header__count') || n.querySelector('.mc-collection-header__count'))) return true;
      }
      return false;
    }
    new MutationObserver(function (muts) {
      if (!muts.some(touchesCount)) return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        var now = readCount();
        if (!now || now === last) return;
        last = now;
        if (window.mcAnnounce) window.mcAnnounce('Results updated: ' + now);
      }, 700);
    }).observe(root, { childList: true, subtree: true, characterData: true });
  }

  function reinitAfterSwap() {
    initSidebarScripts();
    bindAllFilterLinks();
    bindSortSelect();
    initFilterSheet(sheetWasActiveBeforeSwap);
    sheetWasActiveBeforeSwap = false;
    /* Real fix (list-view-toggle-breaks-after-ajax-filter-prompt.md) —
       initViewToggle() attaches the Grid/List click listeners, but was
       only ever called once on initial page load. Every AJAX swap
       (fetchAndReplace/finishApply -> swapSectionHtml -> reinitAfterSwap)
       replaces .mc-collection-section's innerHTML wholesale, destroying
       the old toggle buttons — including their listeners — and creating
       brand new ones with none. Re-run it here so the fresh buttons work
       again; it already reads localStorage's saved view mode internally,
       so the separate viewPref check just below stays a harmless no-op
       once this runs first. */
    initViewToggle();
    if (window.MC && typeof window.MC.initSinglesFilters === 'function') {
      window.MC.initSinglesFilters();
    }
    if (window.MC && typeof window.MC.initSealedFilters === 'function') {
      window.MC.initSealedFilters();
    }
    if (window.MC && typeof window.MC.initPokemonFilters === 'function') {
      window.MC.initPokemonFilters();
    }
    if (window.MC && typeof window.MC.initTcgSealedFilters === 'function') {
      window.MC.initTcgSealedFilters();
    }
    var viewPref = mcStoreGet('mc-view-mode');
    if (viewPref === 'list') setView('list');
    var header = document.querySelector('.mc-collection-header');
    /* On ≤1023px the header box is display:contents (steady filter bar — see assets/monmouth-mobile-fixes.css), so it has no
       box to scroll to; use the breadcrumb row, which sits at the same place. */
    if (header && header.getClientRects().length === 0) {
      header = document.querySelector('.mc-mobile-collection-meta') || document.querySelector('.mc-collection-section');
    }
    if (header) {
      setTimeout(function() {
        header.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 80);
    }
    // Real fix (general-filters-wrong-tags-and-empty-state-prompt.md) —
    // re-apply after every swap, whichever path triggered it (a direct
    // Great Deal click, or any other filter changing while Great Deal
    // is still in the URL), since the server-rendered grid this just
    // swapped in never filtered by it (see applyGreatDealFilter's own
    // comment for why).
    applyGreatDealFilter();
  }

  /* Newest is the default sort on every collection view: AJAX filter navigations never re-run the
     pre-paint redirect, so add sort_by=created-descending here when the target has none (same exceptions:
     an existing sort_by, a tag-based sort in the path, body[data-mc-default-newest="off"]). */
  function withDefaultNewest(url) {
    try {
      if (document.body && document.body.dataset.mcDefaultNewest === 'off') return url;
      var u = new URL(url, window.location.origin);
      if (u.searchParams.has('sort_by') || /\/sort-[^/]*/i.test(u.pathname)) return url;
      u.searchParams.set('sort_by', 'created-descending');
      return u.pathname + u.search;
    } catch (e) { return url; }
  }

  function sameCollectionUrl(url) {
    var base = sidebarAttrs().collectionUrl;
    var path = new URL(url, window.location.origin).pathname;
    return !!base && (path === base || path.indexOf(base + '/') === 0);
  }

  function fetchAndReplace(url) {
    url = withDefaultNewest(url);
    /* A selection that needs several requests cannot be shown by fetching a plain URL (the server would AND the path tags and
       OR every repeated tag, whatever their groups). Take the non-chip params of this URL (sort, price, brand, page size...)
       and re-apply the whole selection through the combination engine instead. */
    if (computePlan().combos.length > 1 && sameCollectionUrl(url)) {
      var np = new URLSearchParams(new URL(url, window.location.origin).search);
      ['filter.p.tag', 'page', 'cp', 'mc_or'].forEach(function(k) { np.delete(k); });
      var nps = np.toString();
      nativeSearchOverride = nps ? '?' + nps : '';
      applyFilters();
      return;
    }
    if (isLoading) return;
    isLoading = true;
    showLoading();

    fetchSectionHtml(url)
      .then(function(html) {
        swapSectionHtml(html);
        history.pushState({ mcUrl: url }, '', url);
        hideLoading();
        isLoading = false;
        reinitAfterSwap();
        multiSelect.bootstrapFromDom();
        /* The chips live in the address bar (filter.p.tag), not in what the server rendered for the path: re-mark them. */
        syncCheckboxStates();
        rebuildPills();
        /* the swapped-in page was fetched for the URL as is (path tags AND, repeated tags OR): when the selection needs
           several requests under the group model, replace it with the merged result */
        ensureGroupData().then(function() {
          var plan = computePlan();
          if (plan.combos.length > 1) renderCombos(plan.combos, buildFilterUrl(), { pushState: false });
        });
      })
      .catch(function(err) {
        console.warn('[MC] AJAX filter failed, falling back:', err);
        hideLoading();
        isLoading = false;
        window.location.href = url;
      });
  }

  /* ── Bind all filter + pagination links ── */
  function bindAllFilterLinks() {
    var selectors = [
      '.mc-sidebar__option',
      '.mc-filter-sheet__option',
      '.mc-sidebar__clear-all',
      '.mc-sidebar__pill',
      '.mc-pagination a'
    ].join(', ');

    document.querySelectorAll(selectors).forEach(function(el) {
      /* Clone to remove any existing listeners */
      var fresh = el.cloneNode(true);
      el.parentNode.replaceChild(fresh, el);

      /* Sidebar/filter-sheet checkbox-style options route through the
         multi-select-aware engine (so they never silently drop an
         active OR-group); everything else (pagination, sort's own
         handler, clear-all) keeps the plain single-URL swap. */
      var isFilterOption = fresh.classList.contains('mc-sidebar__option') ||
                            fresh.classList.contains('mc-filter-sheet__option');

      if (isFilterOption && fresh.hasAttribute('data-tag')) {
        fresh.addEventListener('click', function(e) {
          e.preventDefault();
          multiSelect.toggle(this.getAttribute('data-tag'), this.getAttribute('data-category'));
        });
      } else if (isFilterOption && fresh.getAttribute('data-sort-kind') === 'native') {
        /* Real fix (fix-new-releases-tag-and-bestseller-sort-prompt.md,
           Part 2) — General filter "Best Sellers" shortcut for the Sort
           dropdown's native sort_by (see bindSortSelect()'s own 'native'
           branch above, same logic reused here). Built from
           window.location.href, not this link's own rendered href — a
           server-rendered href can't preserve an active native filter
           (e.g. Price Range) since Liquid's request.search excludes
           natively-processed params entirely (confirmed live), but the
           real browser URL always has everything. Toggles: clicking
           again (or whenever this exact sort is already active) removes
           sort_by instead of re-setting it, since unlike the dropdown
           this is a checkbox, not a single-select. */
        fresh.addEventListener('click', function(e) {
          e.preventDefault();
          var nativeSortBy = this.getAttribute('data-native-sort-by');
          var url = new URL(window.location.href);
          if (url.searchParams.get('sort_by') === nativeSortBy) {
            url.searchParams.delete('sort_by');
          } else {
            url.searchParams.set('sort_by', nativeSortBy);
          }
          url.searchParams.delete('page'); url.searchParams.delete('cp');
          fetchAndReplace(url.toString());
        });
      } else if (isFilterOption && fresh.hasAttribute('data-native-filter')) {
        /* Real fix (general-filters-wrong-tags-and-empty-state-prompt.md)
           — Great Deal isn't a tag at all (see sections/monmouth-
           collection-filters.liquid's compare_at_price check), so it
           can't go through the tag-toggle engine above; it's a plain
           boolean query param instead, toggled the same way Best
           Selling's data-native-sort-by handles sort_by just above, off
           the real browser URL rather than this link's own rendered
           href for the same reason (a server-rendered href can't
           preserve another already-active native param). */
        fresh.addEventListener('click', function(e) {
          e.preventDefault();
          var param = this.getAttribute('data-native-filter');
          var url = new URL(window.location.href);
          if (url.searchParams.get(param) === '1') {
            url.searchParams.delete(param);
          } else {
            url.searchParams.set(param, '1');
          }
          url.searchParams.delete('page'); url.searchParams.delete('cp');
          fetchAndReplace(url.toString());
        });
      } else if (fresh.classList.contains('mc-sidebar__clear-all')) {
        fresh.addEventListener('click', function(e) {
          e.preventDefault();
          multiSelect.clearAll();
        });
      } else {
        fresh.addEventListener('click', function(e) {
          var href = this.getAttribute('href');
          if (!href || href === '#') return;
          e.preventDefault();
          fetchAndReplace(href);
        });
      }
    });
  }

  /* ── Browser back / forward ──
     Re-derives multi-select state from the URL being navigated TO
     (not the stale DOM) and re-runs the same combo-fetch-and-merge
     pipeline as a click would, just without pushing a new history
     entry — the browser already has the right one. */
  window.addEventListener('popstate', function() {
    bootstrapFromLocation();
    ensureGroupData().then(function() {
      applyUrl(window.location.pathname + window.location.search, { pushState: false });
    });
  });

  /* ══════════════════════════════════════════════════════
     MULTI-SELECT OR FILTER ENGINE
     Grading Company / Grade / Brand / Team can each have more than one
     value active at once ("PSA or SGC"). Shopify's own collection tag
     URLs only ever AND tags together (/handle/psa+sgc means "has both",
     not "has either" — no native OR without an app), so this fetches
     one Sections-API result PER selected value in an OR'd category,
     unions the returned products by dedupe, and stitches them into one
     grid. Categories with 0 or 1 value selected need no extra work and
     go through the plain single-fetch path.

     Known simplifications (documented, not silent):
     - Follows each combo's own pagination up to MAX_PAGES_PER_COMBO pages
       (not just page 1) so realistic category sizes come through close
       to complete, but a tag with more matches than that cap still won't
       show every one when OR'd with another. Also capped at MAX_COMBOS
       combos total, to avoid a request storm if several categories are
       multi-selected at once (worst case: MAX_COMBOS × MAX_PAGES_PER_COMBO
       requests).
     - Merged results aren't paginated (there's no single "page 2" across
       a union of several tags' own separate result sets) — pagination is
       hidden while a merge is active rather than shown broken.
     - Sort order is preserved *within* each combo's fetch but combos are
       simply concatenated after dedup, not globally re-sorted.

     The real Shopify URL (path-tag, AND-only) is used for every fetch.
     The *address bar* also carries a `mc_or` query param encoding which
     categories have 2+ values selected, purely so a page refresh or
     shared link restores the merge correctly instead of silently
     falling back to Shopify's own (wrong, AND-only) interpretation of
     that same path.
  ══════════════════════════════════════════════════════ */
  /* 'status' (TCG-Sealed's status- "Availability" checkbox) removed
     2026-07-16 — it duplicated the native Availability filter that
     already renders on every collection page, per user feedback.
     'rpgtype'/'players' added same day for RPG & Tabletop's Product Type
     /Player Count filters — 'brand'/'format' already existed and are
     reused as-is (RPG's Publisher/Format never coexist on a page with
     Sports/Wax's own Brand/Format). 'supply'/'fits'/'packsize' added
     same day for Supplies' Product/Fits Card Type/Pack Size — 'brand'
     reused again for Supplies' own Brand filter. 'mini'/'scale'/
     'ministate' added same day for Miniatures' Line/Scale/State —
     'brand' reused a fourth time for Miniatures' own Brand filter.
     'boardgame'/'age'/'playtime' added same day for Board Games' Type/
     Age Range/Play Time — 'brand' reused a fifth time and 'players' a
     second time (different real value sets than RPG's own Player Count,
     same safe-reuse reasoning). */
  /* 'preorder' added (general-filters-wrong-tags-and-empty-state-
     prompt.md) — General filter's single "Pre-Order" checkbox needs to
     match EITHER of two real tag spellings (PRE_ORDER or pre-order), an
     OR, which Shopify's own AND-only tag-URL routing can't express in
     one path segment — same multi-combo-fetch-and-merge mechanism as
     Grading Company's "PSA or SGC", just always toggled as a pair (see
     toggle()'s '|'-alias handling below) instead of picked individually. */
  var MULTI_CATEGORIES = ['grading-company', 'grade', 'brand', 'team', 'format', 'box-type', 'set', 'rarity', 'finish', 'lang', 'attr', 'character', 'sealedtype', 'year', 'game', 'rpgtype', 'edition', 'players', 'supply', 'fits', 'packsize', 'mini', 'scale', 'ministate', 'boardgame', 'age', 'playtime', 'sport', 'preorder',
    /* 2026-10-26: snake_case attribute groups (Southern Hobby / GTS tags) */
    'thickness', 'capacity', 'storagetype', 'color', 'diceset', 'dicestyle', 'hobbyproduct', 'painttype', 'gamerole', 'franchise', 'tcgproduct', 'tcgset', 'miniline', 'minitype', 'faction', 'kittype', 'series', 'producttype'];

  /* Pokemon Singles tags are namespaced (condition-Graded, gradingco-PSA,
     set-Prismatic Evolutions, ...) unlike Sports Singles' plain tags —
     stripped here purely for pill/chip display, same list the Liquid
     side strips in snippets/monmouth-filter-sidebar.liquid's pill loop.
     sealedtype-/year-/status- added for TCG & Pokemon Sealed collections
     (set-/lang- already covered above, reused from Wax/Pokemon). game-
     added for the combined tcg-pokemon page's Game filter. rpgtype-/
     edition-/players-/brand-/format- added for RPG & Tabletop — brand-/
     format- are new prefixed forms here even though the 'brand'/'format'
     categories already existed (Sports/Wax use those two unprefixed).
     supply-/fits-/packsize- added for Supplies. mini-/scale-/ministate-
     added for Miniatures. boardgame-/age-/playtime- added for Board
     Games. */
  var KNOWN_TAG_PREFIXES = ['condition-', 'gradingco-', 'grade-', 'set-', 'rarity-', 'finish-', 'lang-', 'player-', 'cardnum-', 'attr-', 'sealedtype-', 'year-', 'status-', 'game-', 'rpgtype-', 'edition-', 'players-', 'brand-', 'format-', 'supply-', 'fits-', 'packsize-', 'mini-', 'scale-', 'ministate-', 'boardgame-', 'age-', 'playtime-', 'sort-',
    'brand_', 'fits_', 'packsize_', 'thickness_', 'capacity_', 'storagetype_', 'color_', 'diceset_', 'dicestyle_', 'hobbyproduct_', 'painttype_', 'rpgtype_', 'edition_', 'format_', 'gamerole_', 'franchise_', 'tcgproduct_', 'tcgset_', 'miniline_', 'minitype_', 'ministate_', 'faction_', 'kittype_', 'series_', 'scale_', 'producttype_'];

  function stripKnownPrefix(tag) {
    for (var i = 0; i < KNOWN_TAG_PREFIXES.length; i++) {
      var p = KNOWN_TAG_PREFIXES[i];
      if (tag.slice(0, p.length) === p) {
        var v = tag.slice(p.length);
        if (p.slice(-1) === '_') v = v.split('_').map(function(w) { return w.charAt(0).toUpperCase() + w.slice(1); }).join(' ');
        return v;
      }
    }
    return tag;
  }
  /* 12 → 20: the Brand "Other" row on /collections/new-single-cards ORs ~16 brand tags at once (snippets/monmouth-filter-sidebar.liquid);
     at 12 it silently dropped the rest. Still a bounded request count (see the note above). */
  var MAX_COMBOS = 20;
  /* Condition: picking one drops the other. Two entries because Sports
     Singles writes the plain tag ('Graded'/'Ungraded' -> handleized
     'graded'/'ungraded') while Pokemon Singles writes the prefixed tag
     ('condition-Graded'/'condition-Ungraded' -> handleized 'condition-
     graded'/'condition-ungraded') — before this fix only the Sports pair
     matched, so on Pokemon pages picking Ungraded while Graded was active
     just AND'd both tags together (a card can never be both -> 0 results)
     instead of swapping. */
  /* Not just pairs despite the name — the toggle() logic below just needs
     "if the just-toggled tag's handle is in this group, drop every OTHER
     handle in the same group," which works for any group size. The Sort
     By dropdown's 4 tag options (2026-07-16) are mutually exclusive as a
     group of 4 for the same reason Condition's Graded/Ungraded are a
     group of 2 — picking one sort tag should replace whichever other
     sort tag was active, not AND together into a near-certain 0 results. */
  /* OR filters (owner decision): every chip is OR'd with every other chip, so Graded/Ungraded no longer needs to
     swap ("Graded OR Ungraded" is just everything). Only the Sort By tag options stay mutually exclusive: picking one
     sort tag replaces whichever other sort tag was active. */
  var EXCLUSIVE_PAIRS = [
    ['sort-featured', 'sort-newest', 'bestseller', 'sort-endingsoon']
  ];

  function handleize(str) {
    // Preserve underscores (Shopify's own collection tag-URL routing does
    // not fold them into hyphens the way it does spaces/other punctuation
    // — e.g. tag "PRE_ORDER" must resolve to path segment "pre_order", not
    // "pre-order", or Shopify's server redirects instead of filtering).
    return String(str || '')
      .toLowerCase()
      .replace(/[^a-z0-9_]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  var multiSelectState = { multi: {}, single: [] };
  MULTI_CATEGORIES.forEach(function(c) { multiSelectState.multi[c] = []; });

  /* Real fix (player-autosuggest-race-condition-and-brand-filter-merge-
     prompt.md, Bug 2) — data-request-search is rendered from Liquid's
     request.search, which is empty on this store even when the real
     browser URL genuinely has a query string (confirmed live via a
     temporary debug dump while fixing Great Deal in the previous
     prompt — true for any query param, native or custom). That's the
     actual reason Brand (a native ?filter.p.m.custom.brand=X param) got
     dropped the moment a tag-path filter like Grading Company was
     clicked afterward: buildComboUrl below was appending an always-
     empty string, silently discarding whatever native filter was
     already active. window.location.search is the real, always-
     accurate query string, so read from there instead — `page` is
     stripped so picking a new filter still resets pagination, exactly
     like every filter click already did before this fix (nothing to
     preserve there). sort_by and mc_or aren't stripped: withDefaultNewest
     only adds sort_by when none is present, and buildShareableUrl
     already recomputes mc_or fresh from the live multi-select state
     regardless of what's in the string it's given. */
  /* Set while a link/sort/page-size change is re-applied through the combination engine (see fetchAndReplace). */
  var nativeSearchOverride = null;
  function currentPreservedSearch() {
    if (nativeSearchOverride !== null) return nativeSearchOverride;
    var params = new URLSearchParams(window.location.search);
    params.delete('page');
    params.delete('cp');
    /* The chip filters are rebuilt from the selection state on every request (filter.p.tag / mc_or), so never carry the old ones over. */
    params.delete('filter.p.tag');
    params.delete('mc_or');
    var str = params.toString();
    return str ? '?' + str : '';
  }

  function sidebarAttrs() {
    var aside = document.querySelector('.mc-sidebar');
    return {
      collectionUrl: (aside && aside.getAttribute('data-collection-url')) || '',
      requestSearch: currentPreservedSearch()
    };
  }

  /* Buckets a flat tag list into { multi: {cat: [...]}, single: [...] }
     using the data-category map every [data-category] option in the
     currently-rendered sidebar carries. Shared by both bootstrap paths
     below — the only difference between them is WHERE the flat tag list
     comes from. */
  function categorizeTags(tags) {
    var catByHandle = {};
    document.querySelectorAll('.mc-sidebar__option[data-category]').forEach(function(el) {
      var t = el.getAttribute('data-tag');
      var c = el.getAttribute('data-category');
      /* '|'-delimited alias sets (Pre-Order) register every alias, not the joined string. */
      if (t) String(t).split('|').forEach(function(alias) { catByHandle[handleize(alias)] = c; });
    });

    var next = { multi: {}, single: [] };
    MULTI_CATEGORIES.forEach(function(c) { next.multi[c] = []; });

    tags.forEach(function(t) {
      if (!t) return;
      var h = handleize(t);
      var cat = catByHandle[h];
      if (cat && next.multi[cat]) {
        if (next.multi[cat].indexOf(t) === -1) next.multi[cat].push(t);
      } else if (!next.single.some(function(x) { return handleize(x) === h; })) {
        next.single.push(t);
      }
    });
    return next;
  }

  /* ── FILTER MODEL: OR inside a group, AND between groups ─────────────────────────────────────────────────────────────
     Every chip belongs to a filter group (Condition, Grading Company, Grade, Player, Team, Year, Attributes, General...).
     The result is  (group 1 values OR-ed) AND (group 2 values OR-ed) AND ... , inside the page scope (the Category
     collection / shop_* tag), narrowed further by price, availability, Brand and Great Deal (always AND).
     Shopify gives us two building blocks:
       - tag path segments  /collection/a+b   -> AND  (a card must carry both tags)
       - repeated ?filter.p.tag=a&filter.p.tag=b -> OR (server-side, exact tag, only on collections where the sidebar reports
         filter.p.tag in data-filter-params), and it is ANDed with the path tags.
     So one request can express ONE OR-ed group (the "carrier", sent as repeated filter.p.tag) plus any number of AND-ed
     single-valued groups (path tags). When 2+ groups have several values, the other multi-valued groups are expanded into
     one request per combination of their values (distributive law, (a|b)&(c|d) = ac|ad|bc|bd), merged and de-duplicated in
     the theme (computePlan / renderCombos). On very large collections Shopify ignores filter.p.tag, so there every
     group is expanded that way (LEGACY mode). groupOfTag() tells which group a tag belongs to. */
  var SCOPE_TAG_HANDLES = ['shop_singles', 'shop_sealed', 'shop_accessories', 'sort-featured', 'sort-newest', 'sort-endingsoon', 'sort-bestseller'];
  function isScopeTag(t) { return SCOPE_TAG_HANDLES.indexOf(handleize(t)) !== -1; }

  function nativeTagMode() {
    var aside = document.querySelector('.mc-sidebar');
    var params = (aside && aside.getAttribute('data-filter-params')) || '';
    var key = 'mc_native_tag:' + ((aside && aside.getAttribute('data-collection-url')) || '');
    if (params.split(',').indexOf('filter.p.tag') !== -1) {
      try { sessionStorage.setItem(key, '1'); } catch (e) {}
      return true;
    }
    /* A page whose path tags match nothing renders without any filters, which says nothing about the collection: remember
       that this collection did offer them (very large collections never do). */
    if (!params) { try { return sessionStorage.getItem(key) === '1'; } catch (e) {} }
    return false;
  }

  /* Path segments are handleized; map one back to the real tag text of its sidebar option so native (exact-match) params get the right case. */
  var rawTagCache = {};
  function rawTagForHandle(handle) {
    if (rawTagCache[handle]) return rawTagCache[handle];
    var found = null;
    document.querySelectorAll('.mc-sidebar__option[data-tag]').forEach(function(el) {
      if (found) return;
      String(el.getAttribute('data-tag')).split('|').forEach(function(alias) {
        if (!found && handleize(alias) === handle) found = alias;
      });
    });
    /* Tags that have no sidebar option (players, sets...) come from the tag names Shopify itself resolved for the path
       (collection.current_tags, rendered into the sidebar on the first load). */
    if (!found) found = learnPathTagNames(document)[handle] || null;
    if (found) rawTagCache[handle] = found;
    return found || handle;
  }

  /* Reads the real tag text of the path tags from a rendered collection page (the sidebar prints them from the first
     product, because Shopify's own current_tags only echoes the URL handle) and remembers it. */
  function learnPathTagNames(doc) {
    var aside = doc.querySelector('.mc-sidebar');
    var raw = (aside && aside.getAttribute('data-path-tag-names')) || '';
    raw.split('||').forEach(function(t) { if (t) rawTagCache[handleize(t)] = t; });
    return rawTagCache;
  }

  /* Old /handle/a+b links for tags that have no sidebar option (players, sets...): the real, case-exact tag text is
     learned from one single-tag page per unresolved handle, before the OR request is built. */
  function resolvePathTagNames() {
    var missing = pathTagHandles().filter(function(h) { return !isScopeTag(h) && !rawTagCache[h] && rawTagForHandle(h) === h; });
    if (!missing.length) return Promise.resolve();
    var base = sidebarAttrs().collectionUrl;
    return Promise.all(missing.map(function(h) {
      return fetch(base + '/' + h + '?sections=monmouth-collection-filters', { credentials: 'same-origin' })
        .then(function(r) { return r.json(); })
        .then(function(j) {
          var doc = new DOMParser().parseFromString(j['monmouth-collection-filters'] || '', 'text/html');
          learnPathTagNames(doc);
        })
        .catch(function() {});
    }));
  }

  function pathTagHandles() {
    var attrs = sidebarAttrs();
    /* No filter sidebar on this page (e.g. the Mystery Packs collection) = no tag filters in the path. Without this, the whole
       path "collections/mystery-packs" was read as one tag handle and the address bar was rewritten to
       /collections-mystery-packs?sort_by=... (a 404 on Back / reload). */
    if (!attrs.collectionUrl) return [];
    var rest = window.location.pathname;
    if (attrs.collectionUrl && rest.indexOf(attrs.collectionUrl) === 0) rest = rest.slice(attrs.collectionUrl.length);
    rest = rest.replace(/^\//, '');
    return rest ? rest.split('+') : [];
  }

  function tagsFromLocation() {
    var out = [];
    var seen = {};
    function add(t) {
      var h = handleize(t);
      if (!t || seen[h]) return;
      seen[h] = true;
      out.push(t);
    }
    pathTagHandles().forEach(function(h) { add(rawTagForHandle(h)); });
    new URLSearchParams(window.location.search).getAll('filter.p.tag').forEach(add);
    return out;
  }

  /* Source of truth for the chip state is ALWAYS the address bar (path scope/legacy tags + filter.p.tag + legacy mc_or):
     after an AJAX swap, after back/forward, and on first load. */
  function bootstrapFromLocation() {
    multiSelectState = categorizeTags(tagsFromLocation());
    applyShareParamToState();
  }
  function bootstrapFromDom() { bootstrapFromLocation(); }

  /* Old shared links: ?mc_or=cat:v1,v2|cat2:... (the previous multi-select carrier) still restores its values. */
  function applyShareParamToState() {
    var params = new URLSearchParams(window.location.search);
    var raw = params.get('mc_or');
    if (!raw) return;
    raw.split('|').forEach(function(part) {
      var sep = part.indexOf(':');
      if (sep === -1) return;
      var cat = part.slice(0, sep);
      var vals = part.slice(sep + 1).split(',');
      if (!multiSelectState.multi[cat]) return;
      vals.forEach(function(v) {
        var decoded = decodeURIComponent(v);
        if (decoded && multiSelectState.multi[cat].indexOf(decoded) === -1) {
          multiSelectState.multi[cat].push(decoded);
        }
      });
    });
  }

  function scopeTags() { return multiSelectState.single.filter(isScopeTag); }

  /* Every chip, de-duplicated, raw tag text. The '|' alias pair (Pre-Order) was already split into its two real tags. */
  function chipTags() {
    var out = [];
    function add(t) {
      if (!t) return;
      if (!out.some(function(o) { return handleize(o) === handleize(t); })) out.push(t);
    }
    multiSelectState.single.forEach(function(t) { if (!isScopeTag(t)) add(t); });
    MULTI_CATEGORIES.forEach(function(cat) { multiSelectState.multi[cat].forEach(add); });
    return out;
  }

  /* ── which group does a tag belong to? ──
     1. the sidebar: every option sits inside a .mc-sidebar__group[data-filter="condition|grade|year|general|..."] (remembered
        across section swaps in groupRegistry);
     2. values that arrive from the autocompletes (Player, Team, Set) register their category when they are picked;
     3. namespaced tags (set-X, character-X, cardnum-X, ...): the prefix;
     4. a tag typed in a URL that is none of the above (a player from a shared link): the autocomplete data files
        (players / teams / sets lists) are read once, only when needed (ensureGroupData);
     5. anything still unknown becomes a group of its own, so it can only narrow, never widen. */
  var groupRegistry = {};
  var groupLookups = null;
  function refreshGroupRegistry() {
    document.querySelectorAll('.mc-sidebar__option[data-tag]').forEach(function(el) {
      var g = el.closest('.mc-sidebar__group');
      var gid = g && g.getAttribute('data-filter');
      if (!gid) return;
      String(el.getAttribute('data-tag')).split('|').forEach(function(a) { groupRegistry[handleize(a)] = gid; });
    });
  }
  function registerGroup(tag, group) {
    if (!tag || !group) return;
    String(tag).split('|').forEach(function(a) { var h = handleize(a); if (!groupRegistry[h]) groupRegistry[h] = group; });
  }
  function prefixGroup(tag) {
    for (var i = 0; i < KNOWN_TAG_PREFIXES.length; i++) {
      var p = KNOWN_TAG_PREFIXES[i];
      if (String(tag).slice(0, p.length) === p) return p.replace(/[-_]$/, '');
    }
    return null;
  }
  function groupOfTag(tag) {
    var h = handleize(tag);
    if (!groupRegistry[h]) refreshGroupRegistry();
    if (groupRegistry[h]) return groupRegistry[h];
    var pg = prefixGroup(tag);
    if (pg) return pg;
    if (groupLookups) {
      for (var k in groupLookups) { if (groupLookups[k][h]) return k; }
    }
    return 'tag:' + h;
  }
  function groupResolvable(tag) {
    var h = handleize(tag);
    if (!groupRegistry[h]) refreshGroupRegistry();
    return !!groupRegistry[h] || !!prefixGroup(tag);
  }
  /* Reads the autocomplete lists (already cached by the browser when the shopper used the search boxes) once, and only
     when a chip's group cannot be told any other way. Always resolves. */
  function ensureGroupData() {
    if (groupLookups) return Promise.resolve();
    var unknown = chipTags().some(function(t) { return !groupResolvable(t); });
    if (!unknown) return Promise.resolve();
    var sources = [
      ['MC_SINGLES_FILTER_DATA_URL', { players: 'player', teams: 'team' }],
      ['MC_POKEMON_FILTER_DATA_URL', { sets: 'set', characters: 'character', cardNumbers: 'cardnum' }],
      ['MC_SEALED_FILTER_DATA_URL', { sets: 'set' }]
    ];
    var lookups = {};
    return Promise.all(sources.map(function(src) {
      var url = window[src[0]];
      if (!url) return null;
      return fetch(url, { credentials: 'same-origin' }).then(function(r) { return r.json(); }).then(function(data) {
        Object.keys(src[1]).forEach(function(key) {
          var g = src[1][key];
          (data[key] || []).forEach(function(name) { (lookups[g] = lookups[g] || {})[handleize(name)] = 1; });
        });
      }).catch(function() {});
    })).then(function() { groupLookups = lookups; });
  }

  /* The request plan for the current selection: a list of "combos" (each = one request) whose union is the answer.
     combo = array of path tags (AND) with combo.native = tags sent as repeated filter.p.tag (OR). One combo = the server
     renders the final result by itself (counts, paging, sorting); several = merged in the theme. */
  function collisionProne(tag) { return /^#?\d{1,4}(\.\d+)?$/.test(String(tag).trim()); }

  function computePlan() {
    var scope = scopeTags().slice();
    var groups = [], byId = {};
    chipTags().forEach(function(t) {
      var g = groupOfTag(t);
      if (!byId[g]) { byId[g] = { id: g, tags: [] }; groups.push(byId[g]); }
      byId[g].tags.push(t);
    });
    var multi = groups.filter(function(g) { return g.tags.length >= 2; });
    var singles = groups.filter(function(g) { return g.tags.length < 2; });
    /* The carrier is matched on the EXACT tag text; path segments match on the tag's handle, so a path "8" also matches the
       card-number tag "#8" (6 extra cards among the 75 grade-8 cards on Baseball Singles). Pure-number tags (grades, years,
       card numbers) are the ones that collide, so their group is the carrier whenever there is one; otherwise the largest
       multi-valued group (fewest extra requests), otherwise the first group. */
    var carrier = null;
    function largest(list) { return list.reduce(function(a, b) { return b.tags.length > a.tags.length ? b : a; }); }
    if (nativeTagMode() && groups.length) {
      var prone = groups.filter(function(g) { return g.tags.some(collisionProne); });
      if (prone.length) carrier = largest(prone);
      else if (multi.length) carrier = largest(multi);
      else carrier = singles[0];
    }
    var fixed = scope.slice();
    singles.forEach(function(g) { if (g !== carrier) fixed.push(g.tags[0]); });
    var combos = [fixed];
    multi.forEach(function(g) {
      if (g === carrier) return;
      var next = [];
      combos.forEach(function(c) { g.tags.forEach(function(t) { next.push(c.concat([t])); }); });
      combos = next;
    });
    var truncated = combos.length > MAX_COMBOS;
    if (truncated) combos = combos.slice(0, MAX_COMBOS);
    combos.forEach(function(c) { c.native = carrier ? carrier.tags.slice() : []; });
    combos.truncated = truncated;
    return { combos: combos, groups: groups, carrier: carrier };
  }
  function computeCombos() { return computePlan().combos; }

  function buildComboUrl(comboTags) {
    var attrs = sidebarAttrs();
    /* Shopify answers a tag path with a redirect unless its segments are in its own (alphabetical) order, and the theme treats
       a redirect as "no such tag": always send them sorted. */
    var handles = comboTags.map(handleize).filter(Boolean).sort();
    var path = handles.length ? '/' + handles.join('+') : '';
    var q = attrs.requestSearch;
    if (comboTags.native && comboTags.native.length) {
      var params = new URLSearchParams(q.replace(/^\?/, ''));
      comboTags.native.forEach(function(t) { params.append('filter.p.tag', t); });
      q = '?' + params.toString();
    }
    return attrs.collectionUrl + path + q;
  }

  /* The address-bar URL when the selection needs several requests: scope in the path, every chip as a repeated filter.p.tag
     param (the groups are worked out again from the tags on load), everything else carried over untouched. */
  function buildFilterUrl() {
    var attrs = sidebarAttrs();
    var scope = scopeTags().map(handleize).filter(Boolean);
    var path = attrs.collectionUrl + (scope.length ? '/' + scope.join('+') : '');
    var params = new URLSearchParams(currentPreservedSearch().replace(/^\?/, ''));
    chipTags().forEach(function(t) { params.append('filter.p.tag', t); });
    var q = params.toString();
    return path + (q ? '?' + q : '');
  }

  /* One request: the URL IS the request (the server already returns the right result for it, so a reload or a shared link
     needs no JavaScript); several: the all-chips form above. */
  function buildShareUrl() {
    var plan = computePlan();
    if (plan.combos.length <= 1) return buildComboUrl(plan.combos[0]);
    return buildFilterUrl();
  }

  function cardKey(card) {
    var a = card.querySelector('a[href^="/products/"]');
    return a ? a.getAttribute('href').split('?')[0] : null;
  }

  /* Merge mode hides pagination (there's no single "page 2" across a
     union of several tags' results), so a single page-1-only fetch per
     combo would badly under-represent any tag with more matches than one
     page holds — PSA alone runs well past 200 products on this catalog.
     These follow each combo's own "Next" link up to MAX_PAGES_PER_COMBO
     pages before giving up, so a merge is actually close to complete for
     realistic category sizes instead of just the first 24. */
  var MAX_PAGES_PER_COMBO = 8;
  /* LEGACY merge only: true when some chip had more matches than MAX_PAGES_PER_COMBO pages, so the count reads "N+". */
  var mergeTruncated = false;

  function extractCards(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var grid = doc.getElementById('mc-product-grid');
    return {
      cards: grid ? Array.from(grid.children) : [],
      hasNext: !!doc.querySelector('.mc-pagination__btn--next')
    };
  }

  function withPageParam(url, page) {
    var u = new URL(url, window.location.origin);
    u.searchParams.set('page', String(page));
    return u.pathname + u.search;
  }

  /* Fetches every page of one combo's results (page 1 included), up to
     the cap. Used for every combo except the primary one, which already
     has its page 1 in hand from the section swap. */
  function fetchAllComboCards(comboTags) {
    var url = buildComboUrl(comboTags);
    function loop(page, acc) {
      var pageUrl = page > 1 ? withPageParam(url, page) : url;
      return fetchSectionHtmlChecked(pageUrl).then(function(res) {
        // Real fix (general-filters-wrong-tags-and-empty-state-prompt.md)
        // — a combo tag Shopify redirected away from (doesn't handleize-
        // match any real tag at all) contributes 0 cards, not whatever
        // the redirect landed on (typically the whole unfiltered
        // collection) — see fetchSectionHtmlChecked's own comment.
        if (res.wasRedirected) return acc;
        var extracted = extractCards(res.html);
        var next = acc.concat(extracted.cards);
        if (extracted.hasNext && page < MAX_PAGES_PER_COMBO) {
          return loop(page + 1, next);
        }
        if (extracted.hasNext) mergeTruncated = true;
        return next;
      }).catch(function() { return acc; });
    }
    return loop(1, []);
  }

  /* Fetches pages 2..N of one combo — for the primary combo, whose page 1
     is already live in the DOM (from the section swap or the initial
     page load), so it isn't re-fetched. */
  function fetchRemainingComboCards(comboTags, hasNext) {
    if (!hasNext) return Promise.resolve([]);
    var url = buildComboUrl(comboTags);
    function loop(page, acc) {
      return fetchSectionHtmlChecked(withPageParam(url, page)).then(function(res) {
        if (res.wasRedirected) return acc;
        var extracted = extractCards(res.html);
        var next = acc.concat(extracted.cards);
        if (extracted.hasNext && page < MAX_PAGES_PER_COMBO) {
          return loop(page + 1, next);
        }
        if (extracted.hasNext) mergeTruncated = true;
        return next;
      }).catch(function() { return acc; });
    }
    return loop(2, []);
  }

  /* Unions product cards from the currently-live grid (whatever combo[0]'s
     page 1 left in the DOM) plus a flat array of extra card elements
     already fetched for every other combo (and any extra pages of
     combo[0] itself, via fetchRemainingComboCards/fetchAllComboCards).
     Handles the case where combo[0] had zero matches — Shopify swaps in
     an ".mc-collection-empty" block instead of a grid for that, which
     would otherwise make the *whole* merge look empty even when another
     combo has real results — by creating a fresh grid element in its
     place. */
  function mergeGridFromCombos(extraCards) {
    var seen = {};
    var cards = [];
    var gridClassName = null;

    var liveGrid = document.getElementById('mc-product-grid');
    if (liveGrid) {
      gridClassName = liveGrid.className;
      Array.from(liveGrid.children).forEach(function(card) {
        var key = cardKey(card);
        if (key) { seen[key] = true; cards.push(card); }
      });
    }

    extraCards.forEach(function(card) {
      var key = cardKey(card);
      if (key && !seen[key]) { seen[key] = true; cards.push(card); }
    });

    if (!cards.length) return; /* nothing in any combo — leave the empty-state as-is */

    var main = document.querySelector('.mc-collection-main');
    if (!main) return;

    var grid = document.getElementById('mc-product-grid');
    if (!grid) {
      grid = document.createElement('div');
      grid.id = 'mc-product-grid';
      grid.className = gridClassName || 'mc-product-grid';
      var empty = document.querySelector('.mc-collection-empty');
      if (empty) { empty.replaceWith(grid); } else { main.appendChild(grid); }
    }

    grid.innerHTML = '';
    cards.forEach(function(card) { grid.appendChild(card.cloneNode(true)); });

    /* No single "page 2" across a merged union — hide pagination rather
       than show a broken next-page link, and reflect the true (deduped)
       count instead of whatever page 1 alone reported. */
    var pagination = document.querySelector('.mc-pagination');
    if (pagination) pagination.remove();

    var countEl = document.querySelector('.mc-collection-header__count');
    if (countEl) {
      var n = cards.length;
      countEl.textContent = n + (mergeTruncated ? '+' : '') + ' ' + (n === 1 && !mergeTruncated ? 'product' : 'products');
    }
  }

  /* Marks every tag option (any group) as selected when its tag, or any of its '|' aliases, is in the selection. The
     server only knows the path tags, so chips carried in filter.p.tag / the merge state are applied here. */
  function syncCheckboxStates() {
    var selected = {};
    multiSelectState.single.forEach(function(t) { selected[handleize(t)] = true; });
    MULTI_CATEGORIES.forEach(function(cat) {
      multiSelectState.multi[cat].forEach(function(t) { selected[handleize(t)] = true; });
    });
    document.querySelectorAll('.mc-sidebar__option[data-tag], .mc-filter-sheet__option[data-tag]').forEach(function(el) {
      var tag = el.getAttribute('data-tag');
      if (!tag) return;
      var aliases = tag.indexOf('|') !== -1 ? tag.split('|') : [tag];
      var active = aliases.some(function(a) { return selected[handleize(a)] === true; });
      el.classList.toggle('mc-sidebar__option--selected', active);
      el.setAttribute('aria-pressed', String(active));
    });
  }

  function rebuildPills() {
    var allSelectedTags = multiSelectState.single.slice();
    MULTI_CATEGORIES.forEach(function(cat) {
      /* Real fix (general-filters-wrong-tags-and-empty-state-prompt.md)
         — Pre-Order's 2 aliases are one user-facing filter, not two;
         collapse them to a single composite pill (removing it removes
         both, via toggle()'s existing '|'-alias handling) instead of
         showing "PRE_ORDER" and "pre-order" as two separate pills. */
      if (cat === 'preorder' && multiSelectState.multi[cat].length) {
        allSelectedTags.push(multiSelectState.multi[cat].join('|'));
      } else {
        allSelectedTags = allSelectedTags.concat(multiSelectState.multi[cat]);
      }
    });

    /* The server only renders the pill row / "Clear all" for filters it recognises (a chip that matches nothing, e.g. an
       old bookmark, gets neither): create them so the shopper can always remove the last chip. */
    if (allSelectedTags.length) {
      document.querySelectorAll('.mc-sidebar').forEach(function(sb) {
        var head = sb.querySelector('.mc-sidebar__head');
        if (!head) return;
        if (!sb.querySelector('.mc-sidebar__active-pills')) {
          var box = document.createElement('div');
          box.className = 'mc-sidebar__active-pills';
          head.parentNode.insertBefore(box, head.nextSibling);
        }
        if (!head.querySelector('.mc-sidebar__clear-all')) {
          var c = document.createElement('a');
          c.className = 'mc-sidebar__clear-all';
          c.href = sb.getAttribute('data-collection-url') || window.location.pathname;
          c.textContent = 'Clear all';
          head.appendChild(c);
        }
      });
    }
    /* The desktop sidebar and the mobile filter sheet each render their own sidebar (and so their own pill row and
       "Clear all"); keep every copy in step. */
    document.querySelectorAll('.mc-sidebar__active-pills').forEach(function(container) {
      buildPillsInto(container, allSelectedTags);
    });
    ensureEmptyStateClear();
  }

  function buildPillsInto(container, allSelectedTags) {
    /* Keep any non-tag pills already rendered server-side (Price Range) — only
       replace the tag pills, which is everything with a data-pill-tag marker. */
    container.querySelectorAll('[data-pill-tag]').forEach(function(el) { el.remove(); });

    /* Explicit label overrides for Sort By's 4 tag options — generic
       stripKnownPrefix() + first-letter-uppercase would leave
       "endingSoon" as "EndingSoon" with no space, same reasoning as the
       Liquid-side pill loop's override in monmouth-filter-sidebar.liquid. */
    var SORT_PILL_LABELS = {
      'sort-featured': 'Featured',
      'sort-newest': 'Newest',
      'new_release': 'New Releases',
      /* Real fix (sealed-boxes-pagination-and-sort-tag-bugs-prompt.md) —
         Best Selling's real tag is the bare 'bestseller' (shared with the
         General filter's own "Best Sellers" checkbox), not the old fake
         'sort-bestseller'. Kept alongside it (harmless dead key) in case
         a stale bookmark still carries the old literal tag. */
      'sort-bestseller': 'Best Selling',
      'bestseller': 'Best Sellers',
      'sort-endingsoon': 'Ending Soon',
      /* Sports filter (new-single-cards only) */
      'baseball_cards': 'Sports: Baseball', 'basketball_cards': 'Sports: Basketball', 'football_cards': 'Sports: Football',
      'hockey_cards': 'Sports: Hockey', 'soccer_cards': 'Sports: Soccer', 'racing_cards': 'Sports: Racing',
      'fighting_cards': 'Sports: Fighting', 'pokemon_cards': 'Sports: Pokemon', 'other_cards': 'Sports: Others'
    };

    var chipLabels = {};
    allSelectedTags.forEach(function(tag) {
      var pill = document.createElement('button');
      pill.type = 'button';
      pill.className = 'mc-sidebar__pill';
      pill.setAttribute('data-pill-tag', tag);
      // Pre-Order's composite "A|B" tag reads as one plain label, not the raw alias pair.
      var displayLabel;
      if (tag.indexOf('|') !== -1) {
        displayLabel = 'Pre-Order';
      } else {
        var pillLabel = SORT_PILL_LABELS[handleize(tag)] || stripKnownPrefix(tag);
        displayLabel = SORT_PILL_LABELS[handleize(tag)] ? pillLabel : (pillLabel.charAt(0).toUpperCase() + pillLabel.slice(1));
      }
      chipLabels[displayLabel.toLowerCase()] = true;
      /* the server pill for a chip reads the raw tag text ("grade-10", "rarity-Rare") */
      tag.split('|').forEach(function(t) { chipLabels[t.toLowerCase()] = true; });
      pill.innerHTML = escapeHtml(displayLabel) +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" style="width:9px;height:9px;margin-left:4px;flex-shrink:0;"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
      pill.addEventListener('click', function() {
        var cat = findCategoryForTag(tag);
        multiSelect.toggle(tag, cat);
      });
      container.insertBefore(pill, container.firstChild);
    });

    /* With the native filter.p.tag carrier the server also renders its own pill for each chip it recognises; drop those
       duplicates (the pills built above are the ones wired to the selection state). */
    container.querySelectorAll('.mc-sidebar__pill:not([data-pill-tag])').forEach(function(el) {
      if (chipLabels[el.textContent.replace(/\s+/g, ' ').trim().toLowerCase()]) el.remove();
    });

    /* "Clear all (N)" = exactly the pills the shopper can see (chips + Price/Brand/Year pills the server rendered). */
    var sidebar = container.closest('.mc-sidebar') || document;
    var clearAllLink = sidebar.querySelector('.mc-sidebar__clear-all');
    if (clearAllLink) {
      clearAllLink.textContent = 'Clear all (' + container.querySelectorAll('.mc-sidebar__pill').length + ')';
    }
  }

  function findCategoryForTag(tag) {
    for (var i = 0; i < MULTI_CATEGORIES.length; i++) {
      var cat = MULTI_CATEGORIES[i];
      // Pre-Order's pill carries the composite "A|B" tag (see rebuildPills) —
      // match it directly, alongside the normal plain-tag lookup for everyone else.
      if (multiSelectState.multi[cat].join('|') === tag) return cat;
      if (multiSelectState.multi[cat].some(function(v) { return v === tag; })) return cat;
    }
    return null;
  }

  function escapeHtml(s) {
    var div = document.createElement('div');
    div.textContent = s;
    return div.innerHTML;
  }

  /* "No products found" with filters on: put a visible way out inside the message itself (on a phone the pills live in
     the filter sheet), next to the existing "Back to Home". */
  function ensureEmptyStateClear() {
    var empty = document.querySelector('.mc-collection-empty');
    if (!empty || empty.querySelector('[data-mc-empty-clear]') || !chipTags().length) return;
    var a = document.createElement('a');
    a.className = 'mc-collection-empty__btn';
    a.setAttribute('data-mc-empty-clear', '1');
    a.textContent = 'Remove filters';
    a.href = sidebarAttrs().collectionUrl + (scopeTags().length ? '/' + scopeTags().map(handleize).join('+') : '');
    a.style.marginBottom = '10px';
    var back = empty.querySelector('.mc-collection-empty__btn');
    if (back) empty.insertBefore(a, back); else empty.appendChild(a);
  }

  /* Breadcrumb third item = the checked Category option. The server renders it (sections/monmouth-collection-filters.liquid)
     and the section swap brings the fresh one in with the grid; this re-reads the checked option from the same swapped
     sidebar so the two can never disagree. Nothing happens on collections with no Category group. */
  function syncBreadcrumbCategory() {
    var group = document.querySelector('aside.mc-sidebar [data-filter="shop-type"]');
    var sel = group && group.querySelector('.mc-sidebar__option--selected');
    var label = sel ? (sel.textContent || '').replace(/\s+/g, ' ').trim() : '';
    if (!label) return;
    document.querySelectorAll('[data-bc-category]').forEach(function(el) {
      if (el.textContent !== label) el.textContent = label;
    });
  }

  function finishApply() {
    nativeSearchOverride = null;
    hideLoading();
    syncBreadcrumbCategory();
    isLoading = false;
    /* reinitAfterSwap() -> initSinglesFilters()/initSealedFilters() already
       renders Team/Set chips once for the fresh DOM; syncCheckboxStates/
       rebuildPills below don't change multiSelectState, just read it, so
       there's nothing left for a second chip-render to fix. */
    reinitAfterSwap();
    syncCheckboxStates();
    rebuildPills();
  }

  /* Fetches combos[0] as the primary full-section swap, then (if there's
     more than one combo) fetches the rest and merges their product cards
     in. Shared by user-driven filter clicks (pushState: true, default)
     and browser back/forward (pushState: false — the history entry for
     that URL already exists). */
  function renderCombos(combos, shareUrl, opts) {
    opts = opts || {};
    var truncatedCombos = !!combos.truncated;
    if (combos.length > MAX_COMBOS) {
      console.warn('[MC] ' + combos.length + ' filter combinations requested, capping at ' + MAX_COMBOS);
      truncatedCombos = true;
      combos = combos.slice(0, MAX_COMBOS);
    }

    var primaryUrl = withDefaultNewest(buildComboUrl(combos[0]));
    shareUrl = withDefaultNewest(shareUrl);

    if (isLoading) return;
    isLoading = true;
    mergeTruncated = truncatedCombos;     /* more combinations than the cap: the count reads "N+" */
    showLoading();

    fetchSectionHtmlChecked(primaryUrl)
      .then(function(primaryRes) {
        swapSectionHtml(primaryRes.html);
        if (opts.replaceState) {
          history.replaceState({ mcUrl: shareUrl }, '', shareUrl);
        } else if (opts.pushState !== false) {
          history.pushState({ mcUrl: shareUrl }, '', shareUrl);
        }

        /* Real fix (general-filters-wrong-tags-and-empty-state-
           prompt.md) — the primary combo's own tag doesn't handleize-
           match any real tag anywhere (Shopify redirected instead of
           filtering), so what just got swapped in is the wrong,
           unfiltered page, not genuine zero-result content. Force the
           grid to a real empty state instead of trusting it — this is
           the same "No products are available for the specified
           filter." state a genuinely-empty-but-valid combo already
           shows via sections/monmouth-collection-filters.liquid's own
           _any_filter_active branch, just applied client-side here
           since the server never got a chance to render it correctly
           for a redirected URL. */
        if (primaryRes.wasRedirected) {
          forceEmptyFilterState();
        }

        if (combos.length <= 1) {
          finishApply();
          return null;
        }

        var primaryHasNext = primaryRes.wasRedirected ? false : extractCards(primaryRes.html).hasNext;
        var fetches = combos.map(function(comboTags, i) {
          return i === 0
            ? fetchRemainingComboCards(comboTags, primaryHasNext)
            : fetchAllComboCards(comboTags);
        });

        return Promise.all(fetches).then(function(cardArrays) {
          mergeGridFromCombos([].concat.apply([], cardArrays));
          finishApply();
        });
      })
      .catch(function(err) {
        console.warn('[MC] Multi-select filter failed, falling back to full navigation:', err);
        nativeSearchOverride = null;
        isLoading = false;
        hideLoading();
        window.location.href = shareUrl;
      });
  }

  /* Real fix (general-filters-wrong-tags-and-empty-state-prompt.md) —
     forces the just-swapped-in grid to a genuine 0-result state:
     removes whatever (wrong, unfiltered) cards and pagination came from
     a redirected fetch, and shows the same copy/markup the Liquid empty
     state itself uses so a redirect-caused zero-match reads identically
     to a real one. mergeGridFromCombos (for Pre-Order-style OR combos)
     still runs after this and correctly leaves it alone/rebuilds it only
     if another combo in the merge genuinely does have real matches. */
  function forceEmptyFilterState() {
    var main = document.querySelector('.mc-collection-main');
    if (!main) return;
    var grid = document.getElementById('mc-product-grid');
    if (grid) grid.remove();
    var pagination = document.querySelector('.mc-pagination');
    if (pagination) pagination.remove();
    if (!document.querySelector('.mc-collection-empty')) {
      var empty = document.createElement('div');
      empty.className = 'mc-collection-empty';
      empty.innerHTML =
        '<div class="mc-collection-empty__icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" style="width:28px;height:28px"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg></div>' +
        '<h2 class="mc-collection-empty__title">No products found</h2>' +
        '<p class="mc-collection-empty__desc">No products are available for the specified filter.</p>' +
        '<a href="/" class="mc-collection-empty__btn">Back to Home</a>';
      main.appendChild(empty);
    }
    var countEl = document.querySelector('.mc-collection-header__count');
    if (countEl) countEl.textContent = '0 products';
  }

  /* Real fix (general-filters-wrong-tags-and-empty-state-prompt.md) —
     Great Deal (real compare_at_price > price) can't be filtered in
     Liquid on this store: request.search is empty even when the real
     browser URL has a genuine query string (confirmed live, true for a
     recognized native param just as much as this custom one — see the
     comments in snippets/monmouth-filter-sidebar.liquid and sections/
     monmouth-collection-filters.liquid), so ?great_deal=1 is invisible
     server-side no matter what fetched this page. Read from
     window.location.search instead (always the real URL) and apply
     entirely client-side: hide any card the server rendered that isn't
     genuinely on sale (data-on-sale, set per-product in snippets/
     monmouth-product-card.liquid off the same real compare_at_price
     check), sync this checkbox's own selected state to match, and fall
     back to the shared empty-state builder if nothing survives. Called
     after every section swap (reinitAfterSwap) and once on initial page
     load, so it stays correct regardless of what triggered the render. */
  /* ENG-04 — "Great Deal" used to look only at the cards already in the page (one chunk of the collection: about 120 products,
     fewer when sold-out ones are skipped) and then claimed "0 products" if none of THOSE were on sale. Now:
       1. the cards already in the page are filtered at once (as before);
       2. if the collection has more chunks, the following chunks are fetched (3 at a time, up to GREAT_DEAL_MAX_CHUNKS of them)
          and every on-sale card found is added;
       3. "0 products" is shown only when everything in the collection was really checked and nothing is on sale; if the cap was
          reached (or a request failed) the page says so ("Showing deals from the first N products ...") instead of pretending,
          and always offers the full collection.
     A newer filter/sort change or navigation cancels the scan (the grid it was filling is gone). */
  var GREAT_DEAL_MAX_CHUNKS = 12;
  var gdScan = 0;

  function dealNote(text, withLink) {
    var grid = document.getElementById('mc-product-grid');
    var main = document.querySelector('.mc-collection-main');
    var el = document.getElementById('mc-deals-note');
    if (!text) { if (el) el.remove(); return; }
    if (!el) {
      el = document.createElement('p');
      el.id = 'mc-deals-note';
      el.className = 'mc-deals-note';
      el.setAttribute('role', 'status');
      var host = grid || main;
      if (!host || !host.parentNode) return;
      host.parentNode.insertBefore(el, host);
    }
    el.textContent = text;
    if (withLink) {
      var u = new URL(window.location.href);
      u.searchParams.delete('great_deal'); u.searchParams.delete('cp');
      var a = document.createElement('a');
      a.href = u.pathname + u.search; a.textContent = ' View the whole collection';
      el.appendChild(a);
    }
  }

  function dealsEmptyState(seen, partial) {
    forceEmptyFilterState();
    var desc = document.querySelector('.mc-collection-empty__desc');
    if (partial && desc) desc.textContent = 'No deals were found in the first ' + seen + ' products of this collection. The rest was not checked.';
    else if (desc) desc.textContent = 'Nothing in this collection is on sale right now.';
    var btn = document.querySelector('.mc-collection-empty__btn');
    if (btn) { var u = new URL(window.location.href); u.searchParams.delete('great_deal'); u.searchParams.delete('cp'); btn.href = u.pathname + u.search; btn.textContent = 'View the whole collection'; }
    dealNote('');
  }

  function dealChunkUrl(template, page) {
    var url = new URL(template, window.location.origin);
    var cur = new URL(window.location.href);
    var seen = {};
    cur.searchParams.forEach(function(v, k) {
      if (k === 'page' || k === 'cp' || k === 'great_deal') return;
      if (!seen[k]) { url.searchParams.delete(k); seen[k] = true; }
      url.searchParams.append(k, v);
    });
    url.searchParams.set('page', String(page));
    return url.pathname + url.search;
  }

  function scanDealChunks(grid, firstSeen, keptSoFar) {
    var token = ++gdScan;
    var nextTemplate = grid.getAttribute('data-next-url') || '';
    var cur = parseInt(grid.getAttribute('data-current-page'), 10) || 1;
    var total = parseInt(grid.getAttribute('data-total-pages'), 10) || cur;
    var pages = [];
    for (var p = cur + 1; p <= total && pages.length < GREAT_DEAL_MAX_CHUNKS; p++) pages.push(p);
    var capped = (cur + pages.length) < total;
    var seen = firstSeen, found = keptSoFar, failed = false;
    dealNote('Checking more of this collection for deals…');

    function alive() { return token === gdScan && document.body.contains(grid); }
    function setCount() {
      var countEl = document.querySelector('.mc-collection-header__count');
      if (countEl && found > 0) countEl.textContent = found + ' ' + (found === 1 ? 'product' : 'products');
    }
    function batch(i) {
      if (!alive()) return;
      if (i >= pages.length) return done();
      var slice = pages.slice(i, i + 3);
      Promise.all(slice.map(function(pg) {
        return fetchSectionHtml(dealChunkUrl(nextTemplate, pg)).then(function(html) {
          var g2 = new DOMParser().parseFromString(html, 'text/html').getElementById('mc-product-grid');
          return g2 ? Array.from(g2.children) : [];
        }).catch(function() { failed = true; return []; });
      })).then(function(lists) {
        if (!alive()) return;
        lists.forEach(function(cards) {
          seen += cards.length;
          cards.forEach(function(c) {
            if (c.hasAttribute('data-on-sale')) { grid.appendChild(document.importNode(c, true)); found++; }
          });
        });
        setCount();
        if (found > 0 && typeof window.mcRepageGrid === 'function') window.mcRepageGrid();
        batch(i + 3);
      });
    }
    function done() {
      if (!alive()) return;
      var partial = capped || failed;
      if (found === 0) { dealsEmptyState(seen, partial); return; }
      setCount();
      if (typeof window.mcRepageGrid === 'function') window.mcRepageGrid();
      dealNote(partial ? 'Showing deals from the first ' + seen + ' products of this collection. The rest was not checked.' : '', partial);
    }
    batch(0);
  }

  function applyGreatDealFilter() {
    var active = new URLSearchParams(window.location.search).get('great_deal') === '1';
    document.querySelectorAll('[data-native-filter="great_deal"]').forEach(function(el) {
      el.classList.toggle('mc-sidebar__option--selected', active);
      el.setAttribute('aria-pressed', String(active));
    });
    if (!active) { gdScan++; dealNote(''); return; }

    var grid = document.getElementById('mc-product-grid');
    if (!grid) return; // already empty (e.g. a redirected/true zero-result fetch)
    var hasMore = !!grid.getAttribute('data-next-url');
    var seen = grid.children.length;
    var kept = 0;
    Array.from(grid.children).forEach(function(card) {
      if (card.hasAttribute('data-on-sale')) {
        kept++;
      } else {
        card.remove();
      }
    });
    var pagination = document.querySelector('.mc-pagination');
    if (kept === 0 && !hasMore) {
      forceEmptyFilterState();          /* the whole collection was in this page and nothing is on sale: a real zero */
      dealsEmptyState(seen, false);
      return;
    }
    if (pagination) pagination.remove(); // no reliable "page 2 of the on-sale subset" here, same reasoning as the OR-merge grid
    var countEl = document.querySelector('.mc-collection-header__count');
    if (countEl && kept > 0) countEl.textContent = kept + ' ' + (kept === 1 ? 'product' : 'products');
    if (hasMore) scanDealChunks(grid, seen, kept); else dealNote('');
  }

  /* NATIVE mode (and LEGACY with 0-1 chips): one request for the URL, swap, update history. */
  function renderSingleUrl(url, opts) {
    opts = opts || {};
    url = withDefaultNewest(url);
    if (isLoading) return;
    isLoading = true;
    showLoading();

    fetchSectionHtmlChecked(url)
      .then(function(res) {
        swapSectionHtml(res.html);
        if (opts.replaceState) {
          history.replaceState({ mcUrl: url }, '', url);
        } else if (opts.pushState !== false) {
          history.pushState({ mcUrl: url }, '', url);
        }
        if (res.wasRedirected) forceEmptyFilterState();
        finishApply();
      })
      .catch(function(err) {
        console.warn('[MC] Filter request failed, falling back to full navigation:', err);
        nativeSearchOverride = null;
        isLoading = false;
        hideLoading();
        window.location.href = url;
      });
  }

  /* One entry point for "show the results for the current selection": one request when one combo is enough, otherwise the
     combination merge. The URL argument is only a fallback; the request always comes from the selection itself. */
  function applyUrl(url, opts) {
    var plan = computePlan();
    if (plan.combos.length <= 1) {
      renderSingleUrl(buildComboUrl(plan.combos[0]), opts);
    } else {
      renderCombos(plan.combos, buildFilterUrl(), opts);
    }
  }

  function applyFilters() {
    ensureGroupData().then(function() { applyUrl(buildShareUrl(), { pushState: true }); });
  }

  /* Same address, whatever the order of the tag path segments or of the repeated params. */
  function sameUrl(a, b) {
    function norm(u) {
      var x = new URL(u, window.location.origin);
      var tags = x.pathname.replace(/^.*\/collections\/[^/]+\/?/, '').split('+').filter(Boolean).map(handleize).sort().join('+');
      var q = [];
      x.searchParams.forEach(function(v, k) { q.push(k + '=' + v); });
      return x.pathname.replace(/\/collections\/([^/]+).*/, '/collections/$1') + '|' + tags + '|' + q.sort().join('&');
    }
    return norm(a) === norm(b);
  }

  /* Runs once on initial page load. The server rendered whatever the URL says (path tags AND, repeated filter.p.tag OR,
     whatever group they came from). Bring the page in line with the group model: several requests needed -> merge; one
     request that is not the one the URL already is (an old /handle/a+b link, a different order) -> fetch the right one;
     already right -> just mark the chips and checkboxes. */
  function restoreOnLoad() {
    var plan = computePlan();
    if (plan.combos.length > 1) {
      renderCombos(plan.combos, buildFilterUrl(), { replaceState: true });
      return;
    }
    if (chipTags().length) {
      var want = withDefaultNewest(buildComboUrl(plan.combos[0]));
      var cur = withDefaultNewest(window.location.pathname + window.location.search);
      if (!sameUrl(cur, want)) {
        renderSingleUrl(want, { replaceState: true });
        return;
      }
    }
    syncCheckboxStates();
    rebuildPills();
  }

  var multiSelect = {
    bootstrapFromDom: bootstrapFromDom,
    getState: function() { return multiSelectState; },
    toggle: function(tag, category) {
      registerGroup(tag, category);        /* Player / Team / Set picked from an autocomplete: remember their group */
      if (category && MULTI_CATEGORIES.indexOf(category) !== -1) {
        var list = multiSelectState.multi[category];
        /* Real fix (general-filters-wrong-tags-and-empty-state-
           prompt.md) — a '|'-delimited tag (currently just Pre-Order's
           "PRE_ORDER|pre-order") is a set of alias spellings for ONE
           user-facing checkbox, always toggled together as a pair: if
           ANY alias is already in the list this removes all of them
           (unchecking), otherwise it adds every alias that isn't already
           present (checking). This is what makes computeCombos() treat
           it as a 2-value OR axis — see the vals.length >= 2 branch. */
        var aliases = tag.indexOf('|') !== -1 ? tag.split('|') : [tag];
        var anyPresent = aliases.some(function(a) {
          return list.some(function(v) { return handleize(v) === handleize(a); });
        });
        if (anyPresent) {
          aliases.forEach(function(a) {
            var idx = list.findIndex(function(v) { return handleize(v) === handleize(a); });
            if (idx !== -1) list.splice(idx, 1);
          });
        } else {
          aliases.forEach(function(a) {
            if (!list.some(function(v) { return handleize(v) === handleize(a); })) list.push(a);
          });
        }
      } else {
        var single = multiSelectState.single;
        var sIdx = single.findIndex(function(v) { return handleize(v) === handleize(tag); });
        if (sIdx !== -1) {
          single.splice(sIdx, 1);
        } else {
          /* Condition (Graded/Ungraded) is mutually exclusive — picking
             one always drops the other rather than AND-ing to zero
             results, since a card can never be both. */
          var h = handleize(tag);
          EXCLUSIVE_PAIRS.forEach(function(pair) {
            if (pair.indexOf(h) !== -1) {
              pair.forEach(function(other) {
                if (other !== h) {
                  var oIdx = single.findIndex(function(v) { return handleize(v) === other; });
                  if (oIdx !== -1) single.splice(oIdx, 1);
                }
              });
            }
          });
          single.push(tag);
        }
      }
      applyFilters();
    },
    removeTag: function(tag) {
      this.toggle(tag, findCategoryForTag(tag));
    },
    clearAll: function() {
      MULTI_CATEGORIES.forEach(function(c) { multiSelectState.multi[c] = []; });
      multiSelectState.single = [];
      applyFilters();
    }
  };

  /* ══════════════════════════════════════════════════════
     PUBLIC HOOKS
     Lets other scripts (monmouth-singles-filters.js) trigger
     the same AJAX section-replace navigation and re-bind newly
     inserted filter links, instead of a hard page reload.
  ══════════════════════════════════════════════════════ */
  window.MC = window.MC || {};
  window.MC.fetchAndReplace = fetchAndReplace;
  window.MC.bindAllFilterLinks = bindAllFilterLinks;
  window.MC.handleize = handleize;
  window.MC.currentPreservedSearch = currentPreservedSearch;
  window.MC.multiSelect = multiSelect;
  /* read-only: how many requests the current selection needs, and which groups it has (used for diagnostics) */
  window.MC.filterPlan = function() {
    var p = computePlan();
    return { requests: p.combos.length, truncated: !!p.combos.truncated, carrier: p.carrier ? p.carrier.id : null,
      groups: p.groups.map(function(g) { return { group: g.id, tags: g.tags.slice() }; }) };
  };

  /* ══════════════════════════════════════════════════════
     INIT ON PAGE LOAD
  ══════════════════════════════════════════════════════ */
  initViewToggle();
  initFilterSheet();
  initResultsAnnouncer();
  initSidebarScripts();
  bindAllFilterLinks();
  bindSortSelect();
  /* old path-tag links may need the real tag text fetched first; everything else starts immediately */
  resolvePathTagNames().then(function() {
    bootstrapFromLocation();
    return ensureGroupData();
  }).then(function() {
    restoreOnLoad();
    syncBreadcrumbCategory();
  });
  applyGreatDealFilter();

})();
